import React from 'react'
import styled from 'styled-components'
import { Text, Flex } from '@radix-ui/themes'

export const WarningStrip: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Wrapper px="2" py="2" justify="center">
      <Text size="2">
        {children}
      </Text>
    </Wrapper>
  )
}

const Wrapper = styled(Flex)`
  background-color: var(--yellow-4);
`